import { Pagination } from '~/Api/Pagination';
import { Item, Product, ProductsStats, Query, QueryErrors } from '~/Api/Product';

export enum ActionType {
	requestProducts = 'Product.requestProducts',
	receiveProducts = 'Product.receiveProducts',
	setQueryErrors = 'Product.setQueryErrors',
	requestProduct = 'Product.requestProduct',
	receiveProduct = 'Product.receiveProduct',
	showAllProductsAction = 'CzMaxPrice.showAllProductsAction',
	pruneProducts = 'Product.pruneProducts',
}

export interface RequestProducts {
	type: ActionType.requestProducts;
	request: Promise<any>;
	query: Query;
}

export type ReceiveProducts =
	| {
			type: ActionType.receiveProducts;
			request: Promise<any>;
			query: Query;
			items: Item[];
			pagination: Pagination;
			paginationLimitReached: boolean;
			stats: ProductsStats;
			queryErrors: QueryErrors | null;
	  }
	| {
			type: ActionType.receiveProducts;
			request: Promise<any>;
			query: Query;
			items: null;
			pagination: null;
			paginationLimitReached: boolean;
			stats: null;
			queryErrors: QueryErrors | null;
	  };

export interface SetQueryErrors {
	type: ActionType.setQueryErrors;
	query: Query;
	errors: QueryErrors;
}

export interface RequestProduct {
	type: ActionType.requestProduct;
	request: Promise<any>;
	id: string;
}

export interface ReceiveProduct {
	type: ActionType.receiveProduct;
	request: Promise<any>;
	id: string;
	product: Product | null | undefined; // tslint:disable-line: no-null-undefined-union
}

export interface ShowAllProductsAction {
	type: ActionType.showAllProductsAction;
	showAll: boolean;
}

export interface PruneProducts {
	type: ActionType.pruneProducts;
	query: Query;
}

export type Action =
	| RequestProducts
	| ReceiveProducts
	| SetQueryErrors
	| RequestProduct
	| ReceiveProduct
	| ShowAllProductsAction
	| PruneProducts;
